var exports = {
  "p": "xcc377c0b--dea680--list",
  "x": "xcc377c0b--dea680--list-item",
};

module.exports = exports;
